const EVENTS = {
  HOTSPOT_SELECTED: 'hotspot:selected',
}

class HotSpots extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (this.els.buttons) {
      this.els.buttons.elements.forEach(button => {
        this.listeners.add(button, 'mouseenter', () =>
          this.handleMouseEnter(button),
        )
      })
      this.listeners.add(this, 'mouseleave', () => this.handleMouseLeave())
      this.listeners.add(this, EVENTS.HOTSPOT_SELECTED, e =>
        this.handleSelected(e),
      )
    }
  }

  handleSelected (e) {
    const selectedId = e.detail.selected
    this.els.buttons.elements.forEach(button => {
      button.dataset.hotSpotsButtonId === selectedId
        ? button.setAttribute('selected', 'true')
        : button.setAttribute('selected', 'false')
    })
  }

  handleMouseEnter (hotspot) {
    this.dispatchEvent(
      new CustomEvent(EVENTS.HOTSPOT_SELECTED, {
        detail: {
          selected: hotspot.dataset.hotSpotsButtonId,
        },
        bubbles: true,
      }),
    )
  }

  handleMouseLeave () {
    this.els.buttons.elements.forEach(button => {
      button.setAttribute('selected', 'false')
    })
  }
}

if (!customElements.get('hot-spots')) {
  customElements.define('hot-spots', HotSpots)
}
